module.exports = __webpack_public_path__ + "img/16_80.f1e57fbb.png";